import { createSelector } from '@reduxjs/toolkit';
import { name } from './slice';
import type { PackageUpsaleOptionsStateType } from './types';

export const getPackageUpsaleOptions = (state): PackageUpsaleOptionsStateType =>
  state[name];

export const getTransferOptions = createSelector(
  getPackageUpsaleOptions,
  (state) => state.transferOptions,
);

export const getExtraOptions = createSelector(
  getPackageUpsaleOptions,
  (state) => state.extraOptions,
);

export const getChosenOptions = createSelector(
  getPackageUpsaleOptions,
  (state) => state.chosenOptions,
);

export const getInsuranceOption = createSelector(
  getPackageUpsaleOptions,
  (state) => state.insuranceOption,
);

export const getIsSelectedInsurance = createSelector(
  [getChosenOptions, getInsuranceOption],
  (chosenOptions, insurance) =>
    Boolean(
      chosenOptions.find(
        (hashsum) => hashsum === insurance?.options[0].hashsum,
      ),
    ),
);

export const getSelectedInsuranceType = createSelector(
  [getIsSelectedInsurance, getInsuranceOption],
  (isSelected, insurance) =>
    isSelected ? insurance?.options[0].variant || null : null,
);

export const getIsInsurable = createSelector(getInsuranceOption, (insurance) =>
  Boolean(insurance),
);
